export default __webpack_public_path__ + "static/media/link-frequently.0bb101ec.svg";